<template>
  <div class="tigan-wrap">
    <TiganTitle :topic="topic" :index="index" />
    <div class="tigan-content">
      <slot />
    </div>
  </div>
</template>
<script>
import TiganTitle from './TiganTitle.vue'
export default {
  components: {
    TiganTitle
  },
  props: {
    topic: Object,
    index: Number
  }
}
</script>
<style lang="less" scoped>
.tigan-wrap {
  min-height: 100%;
  background: #FFFFFF;
  border-radius: 6px;
  // overflow-y: auto;
  // position: relative;
}
.tigan-content {
  padding: 0 14px 14px 34px;
}
</style>